import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./SingleProjectSkeleton.module.scss";

const SingleProjectSkeleton = () => {
  return (
    <section className={styles.singleProjectSkeleton}>
      <div className={styles.projectSkeleton}>
        <div className={styles.header}>
          <Skeleton height={20} width={300} />
          <Skeleton height={15} width={150} />
          <Skeleton height={15} width={120} />
        </div>

        <div className={styles.tags}>
          <Skeleton height={20} width={80} />
          <Skeleton height={20} width={120} />
          <Skeleton height={20} width={150} />
        </div>

        {/* <div className={styles.mediaSection}>
        <Skeleton height={200} />
        <Skeleton height={200} />
        <Skeleton height={200} />
      </div> */}

        <div className={styles.about}>
          <Skeleton height={25} width={200} />
          <Skeleton count={5} />
        </div>

        <div className={styles.skills}>
          <Skeleton height={20} width={100} />
          <Skeleton height={20} width={120} />
          <Skeleton height={20} width={130} />
          <Skeleton height={20} width={110} />
        </div>

        <div className={styles.company}>
          <Skeleton height={20} width={250} />
          <Skeleton count={3} />
        </div>

        <div className={styles.button}>
          <Skeleton height={40} width={120} />
        </div>
      </div>
    </section>
  );
};

export default SingleProjectSkeleton;
